import { TweenMax, Power2 } from 'gsap';

class ScrollTop {
  constructor() {
    this.topLink = document.querySelector('.js--scroll-top');
    this.bindEvents();
  }

  bindEvents() {
    this.topLink.addEventListener('click', this.scroll.bind(this));
  }

  scroll(e) {
    e.preventDefault();

    TweenMax.to(window, 0.8, {
      scrollTo: { y: 0 },
      ease: Power2.easeInOut,
    });
  }
}

export default ScrollTop;
